import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdmin } from '../service/authService';

export default function AdminRoute(props) {
   let checkAdmin = isAdmin();
   if (localStorage.getItem('username')) {
      if (checkAdmin) {
         return <Route {...props} />;
      } else {
         return <Redirect to='/RequestHistory' />;
      }
   } else {
      return <Redirect to='/login' />;
   }
}
